module.exports = __webpack_public_path__ + "img/style_0_1.88ae7ddc.png";